import {createDivIn, createHeaderIn, createImgIn, createParagraphIn} from '../../../../shared/scripts/ui_utils/DomUtils'
import {TranslationObject} from '@colonist/i18n'
import {LobbyImage} from '@colonist/types'
import {ViewPopup} from '../../../../shared/scripts/ui_popup/ViewPopup'

interface RuleInformationBodyElement {
    header: TranslationObject
    text: TranslationObject
    image: LobbyImage
}

export class UIMRoomSettingsRulesInformationViewPopup extends ViewPopup {
    private bodyContainer: HTMLDivElement
    constructor() {
        super({key: 'strings:roomPage.rules.title'},
            {key: 'strings:colonistCommon.utils.emptyString'},
            () => undefined,
            () => undefined,
            true,
            {showXonHeader: true, showXButton: false, showCheckButton: false})

        const rulesInformationBodyElements: RuleInformationBodyElement[] = [
            {
                header: {key: 'strings:roomPage.rules.ruleInformations.privateGame.header'},
                text: {key: 'strings:roomPage.rules.ruleInformations.privateGame.body'},
                image: LobbyImage.PrivateGame,
            },
            {
                header: {key: 'strings:roomPage.rules.ruleInformations.hideBankCards.header'},
                text: {key: 'strings:roomPage.rules.ruleInformations.hideBankCards.body'},
                image: LobbyImage.HideBankCards,
            },
            {
                header: {key: 'strings:roomPage.rules.ruleInformations.friendlyRobber.header'},
                text: {key: 'strings:roomPage.rules.ruleInformations.friendlyRobber.body'},
                image: LobbyImage.Robber,
            },
            {
                header: {key: 'strings:roomPage.rules.ruleInformations.balancedDice.header'},
                text: {key: 'strings:roomPage.rules.ruleInformations.balancedDice.body'},
                image: LobbyImage.Dice6,
            },
            {
                header: {key: 'strings:roomPage.rules.ruleInformations.noTrolls.header'},
                text: {key: 'strings:roomPage.rules.ruleInformations.noTrolls.body'},
                image: LobbyImage.IconNoTroll,
            },
        ]

        this.initializeRulesInformationBody(rulesInformationBodyElements)

        this.show()
    }

    private initializeRulesInformationBody(rulesInformationBody: RuleInformationBodyElement[]) {
        if(this.body.firstChild) this.body.removeChild(this.body.firstChild)

        this.bodyContainer = createDivIn(this.body, 'm-room-settings-rules-information-popup-body-container')
        for(const ruleInformation of rulesInformationBody) {
            const ruleContainer = createDivIn(this.bodyContainer, 'm-room-settings-rules-information-popup-rule-container')
            const imageContainer = createDivIn(ruleContainer, 'm-room-settings-rules-information-popup-rule-image-container')
            createImgIn(imageContainer, ruleInformation.image, 'm-room-settings-rules-information-popup-rule-img')
            const textContainer = createDivIn(ruleContainer, 'm-room-settings-rules-information-popup-rule-text-container')
            createHeaderIn(textContainer, ruleInformation.header, 'm-room-settings-rules-information-popup-rule-header')
            createParagraphIn(textContainer, ruleInformation.text, 'm-room-settings-rules-information-popup-rule-text')
        }
    }
}
